import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import { Button, ButtonToolbar, FormGroup, ControlLabel, Modal, Form, Row, Col } from 'react-bootstrap'

export class ExceptionsColorForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            newBgColor: "",
            newTextColor: "",
            newUseCustomTextColor: false,
            newUseLineColor: false,
            newUseLineTextColor: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.exceptionColor !== this.props.exceptionColor) {
            this.setState({
                newBgColor: "",
                newTextColor: "",
                newUseCustomTextColor: this.props.exceptionColor ? this.props.exceptionColor.useCustomTextColor : false,
                newUseLineColor: this.props.exceptionColor ? this.props.exceptionColor.bgColor === "useLineColor" : false,
                newUseLineTextColor: this.props.exceptionColor ? this.props.exceptionColor.textColor === "useLineColor" : false
            });
        }
    }

    onChangeBgColor(e) {
        if (this.state.newUseLineColor) return;

        this.setState({
            newBgColor: `${e.rgb.r};${e.rgb.g};${e.rgb.b};${e.rgb.a}`
        });
    }

    onChangeTextColor(e) {
        this.setState({
            newTextColor: `${e.rgb.r};${e.rgb.g};${e.rgb.b};${e.rgb.a}`
        });
    }

    onToggleCustomTextColor() {
        this.setState(prev => {
            const newUseCustomText = !prev.newUseCustomTextColor;

            return {
                newUseCustomTextColor: newUseCustomText,
                newUseLineTextColor: newUseCustomText ? false : prev.newUseLineTextColor,
            }
        });
    }

    onToggleUseLineColor() {
        this.setState(prev => {
            const newUseLine = !prev.newUseLineColor;
            return {
                newUseLineColor: newUseLine,
                newBgColor: newUseLine ? prev.newBgColor : prev.newBgColor
            };
        });
    }

    onToggleUseLineTextColor() {
        this.setState(prev => {
            const newUseLineText = !prev.newUseLineTextColor;

            return {
                newUseLineTextColor: newUseLineText,
                newUseCustomTextColor: newUseLineText ? false : prev.newUseCustomTextColor
            };
        });
    }

    onSave() {
        const { exceptionColor } = this.props;
        const { newBgColor, newTextColor, newUseCustomTextColor, newUseLineColor, newUseLineTextColor } = this.state;

        const updatedEntry = {
            bgColor: newUseLineColor ? "useLineColor" : (newBgColor !== "" ? newBgColor : exceptionColor.bgColor),
            textColor: newUseLineTextColor ? "useLineColor" : (newTextColor !== "" ? newTextColor : exceptionColor.textColor),
            useCustomTextColor: newUseLineTextColor ? false : newUseCustomTextColor
        };

        this.setState({ newBgColor: "", newTextColor: "", newUseCustomTextColor: false, newUseLineColor: false, newUseLineTextColor: false }, () => {
            this.props.onSave(updatedEntry);
        });
    }

    onHide() {
        this.setState({ newBgColor: "", newTextColor: "", newUseCustomTextColor: false, newUseLineColor: false, newUseLineTextColor: false }, () => {
            this.props.onHide();
        });
    }

    parseToCss(colorStr) {
        if (!colorStr || colorStr === "useLineColor") {
            return `rgba(0, 0, 0, 1)`;
        }
        const [r, g, b, a] = colorStr.split(";").map(Number);
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    render() {
        const { exceptionColor, title } = this.props;
        const { newBgColor, newTextColor, newUseCustomTextColor, newUseLineColor, newUseLineTextColor } = this.state;

        if (typeof exceptionColor === 'undefined' || exceptionColor === null) {
            return null;
        }

        const bgCssColor = this.parseToCss(newBgColor !== "" ? newBgColor : exceptionColor.bgColor);
        const textCssColor = this.parseToCss(newTextColor !== "" ? newTextColor : exceptionColor.textColor);

        return (
            <Modal show={this.props.show} style={{ maxWidth: '700px', margin: 'auto' }}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col sm={6}>
                                <ControlLabel className="margin-bottom-10">Cor de Fundo</ControlLabel>
                                <FormGroup controlId="formCorFundo">
                                    <ControlLabel style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}
                                        onClick={() => this.onToggleUseLineColor()}>
                                        <input
                                            type="checkbox"
                                            checked={newUseLineColor}
                                            onChange={() => this.onToggleUseLineColor()}
                                            style={{ margin: 0 }}
                                        />
                                        Usar cor da linha
                                    </ControlLabel>
                                    <div style={{ opacity: newUseLineColor ? 0.5 : 1, pointerEvents: newUseLineColor ? 'none' : 'auto' }}>
                                        <SketchPicker
                                            className="sketch-picker"
                                            color={bgCssColor}
                                            onChangeComplete={(color) => this.onChangeBgColor(color)}
                                            styles={{ default: { picker: { width: '270px' } } }}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup controlId="formCorTexto">
                                    <ControlLabel className="margin-bottom-10">Cor do Texto</ControlLabel>
                                    <div style={{ display: 'flex', gap: 20, alignItems: 'center', marginBottom: 10 }}>
                                        <ControlLabel
                                            style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none', margin: 0 }}
                                            onClick={() => this.onToggleCustomTextColor()}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={newUseCustomTextColor}
                                                onChange={() => this.onToggleCustomTextColor()}
                                                style={{ margin: 0 }}
                                            />
                                            Utilizar Cor
                                        </ControlLabel>

                                        <ControlLabel
                                            style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none', margin: 0 }}
                                            onClick={() => this.onToggleUseLineTextColor()}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={newUseLineTextColor}
                                                onChange={() => this.onToggleUseLineTextColor()}
                                                style={{ margin: 0 }}
                                            />
                                            Cor da linha
                                        </ControlLabel>
                                    </div>

                                    <div style={{ opacity: newUseCustomTextColor ? 1 : 0.4, pointerEvents: newUseCustomTextColor ? 'auto' : 'none' }}>
                                        <SketchPicker
                                            className="sketch-picker"
                                            color={textCssColor}
                                            onChangeComplete={(color) => this.onChangeTextColor(color)}
                                            styles={{ default: { picker: { width: '270px' } } }}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}